import PropTypes from 'prop-types';
import React from 'react';
import Button from 'creatella-react-components/lib/Button';
import './OrderConditionPrompt.scss';
import Modal from '../Modal/Modal';

OrderConditionPrompt.propTypes = {
    onClose: PropTypes.func,
    isVisible: PropTypes.bool
};

function OrderConditionPrompt({
    onClose,
    isVisible
}) {
    return (
        <Modal
            // onClose={onClose}
            isVisible={isVisible}
            className='OrderConditionPrompt'
            title={'Warning'}>
            <div className='OrderConditionPrompt__message'>
                For all orders on BANANA products, copy the below text and specify for your order, in the box {'"special conditions"'} the following:
                <ol >
                    <li><b>Category:</b> (e.g. I-premium, I, II)</li>
                    <li><b>Brand Name:</b></li>
                    <li><b>Certification:</b> (e.g. Globalgap, Rainforest Alliance)</li>
                    <li><b>Vessel Name:</b></li>
                    <li><b>Custom Clearance:</b> (e.g. EU custom cleared T2 / EU Custom uncleared T1)</li>
                    <li><b>Pickup Location:</b></li>
                </ol>
            </div>
            <div className='OrderConditionPrompt__button-wrapper'>
                <Button
                    onClick={onClose}
                    className='OrderConditionPrompt__button OrderConditionPrompt__button--close'>
                    Continue
                </Button>
            </div>
        </Modal>
    );
}

export default OrderConditionPrompt;
